import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-report-issue',
  templateUrl: './report-issue.component.html',
  styleUrls: ['./report-issue.component.css']
})
export class ReportIssueComponent implements OnInit {

  selectedOption: any;
  options = [
    {value: 'report_postcard', viewValue: 'Inappropriate postcard'},
    {value: 'report_transcript', viewValue: 'Inappropriate transcription'}
  ];
  reportAction = function () {
    this.dialogRef.close(this.selectedOption);
  };
  close = function () {
    this.dialogRef.close();
  };

  constructor(private dialogRef: MatDialogRef<ReportIssueComponent>) {
  }

  ngOnInit() {
  }
}
